
import { reportingService } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import { rtbLogsService } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import { EXPORT_RTB_LOG, GET_RTB_LOG, GET_RTB_LOG_BY_CALLER_ID } from './actionTypes';
import {
  SET_ACTION_STATUS_PENDING,
  SET_ACTION_STATUS_SUCCESS,
  SET_ACTION_STATUS_ERROR
} from '@/store/helpers';

const actions = {
  async [EXPORT_RTB_LOG]({ dispatch }, data, makeAPICall = true) {
    const dateFormat ='MMM D, YYYY';

    const exportName = 'RTB Logs' + (data.timeRange ? (' (' + data.timeRange[0].format(dateFormat) + ')') : '');

    const apiRequestData = {
      ...reportingService.getReportingDateRange(data.timeRange, data.formatTimeZone),
      formatTimespans: true,
      formatPercentages: true,
      formatDateTime: true,
      generateRollups: true,
      filters: data.filters,
      formatTimeZone: data.formatTimeZone
    };
    
    if (makeAPICall) {
      dispatch('exportFiles/exportRtbLogs', { apiRequestData, exportName }, { root: true });
    } else {
      return apiRequestData;
    }

  },

  async [GET_RTB_LOG]({ rootState, commit }, bidId) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: GET_RTB_LOG });
    try {
      const bidResult = await rtbLogsService.getRtbLog(rootState.currentAccountId, bidId);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: GET_RTB_LOG });
      return bidResult;
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: GET_RTB_LOG, error: e });
    }
  },

  async [GET_RTB_LOG_BY_CALLER_ID]({ rootState, commit }, callerId) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: GET_RTB_LOG_BY_CALLER_ID });
    try {
      const bidResult = await rtbLogsService.getRtbLogByCallerId(rootState.currentAccountId, callerId);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: GET_RTB_LOG_BY_CALLER_ID });
      return bidResult;
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: GET_RTB_LOG_BY_CALLER_ID, error: e });
    }
  },

};
export default actions;